/// <amd-module name="VSSUI/Components/PeoplePickerDropdown/index" />
export * from "./PeoplePickerDropdown";
export { IPeoplePickerDropdown, IPeoplePickerDropdownProps, ISuggestionModel } from "./PeoplePickerDropdown.Props";
